module.exports = __webpack_public_path__ + "static/img/zs-bc.87370b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zs-bc.png
// module id = jIIt
// module chunks = 0